<template>
  <div>
    <el-switch v-model="show_in" active-color="#13ce66" inactive-color="#ff4949">
    </el-switch>
    <label class="pre-inline" v-show="show_in">{{pre_item.name_in}}:</label>
    <label class="pre-inline" v-show="show_out">{{pre_item.name_out}}:</label>

    <input class="pre-input " type="text" :class="[pre_item.class!=''?pre_item.class:'short']" v-model="pre_sel_name"
      :placeholder="pre_item.note" @change="fun_change" />


    <el-select v-model="pre_sel_name" clearable class="pre-inline"
      :class="[pre_item.class!=''?pre_item.class:'short']" placeholder="待选" @change="choseValue">
      <el-option v-for="item in pre_list_data" :key="item.id" :label="item.val" :value="item.id">
      </el-option>
    </el-select>

    <em v-show="pre_item.w=='1'">*</em><em v-show="pre_item.w=='0'"></em>
  </div>
</template>

<script>
  export default {
    name: "hj-selectnew",
    data() {
      return {
        pre_item: {},
        is_active: false,

        pre_sel_val: '',
        pre_sel_name: '',

        show_in: true,
        show_out: false,

        pre_list_data:[],
        pre_list_bak:[],

        pre_list_in: [],
        pre_list_out: []

      }
    },
    props: {
      inData: {
        type: String,
        default: ''
      }
    },
    watch: {
      inData(val) {
        this.init(val);
      },
      show_in(val) {
        console.log('收入判断=' + val);
        this.pre_sel_name = '';
        this.pre_sel_val = '';
        this.pre_list_data=[];
        this.pre_item.sel_name='';
        this.pre_item.val='';
        if (val) {
          this.pre_item.io = 'i';
          this.show_out = false;
          this.pre_list_data=this.pre_list_in;
        } else {
          this.pre_item.io = 'o';
          this.show_out = true;
          this.pre_list_data=this.pre_list_out;
        }

      },
    },
    created() {
      // console.log('hj-select 组件创建时调用 创建');
      // 如果加载数据放到子组件，此处使用
      // this.init();
    },
    mounted: function() {
      // console.log('hj-select 组件加载时调用 mounted');
      // 如果加载数据放到父组件，此处使用
      // console.log('组件完成创建')
      this.init();
    },
    activated: function() {
      // console.log('hj-select 组件激活时调用 激活');

      this.init();
    },
    deactivated: function() {
      // console.log('hj-select 组件激活时调用 停用');
      this.pre_item = {};
      this.pre_list_in = [];
      this.pre_list_out = [];
      this.pre_sel_name = '';
      this.pre_sel_val = '';

      this.is_active = false;
    },
    methods: {
      refresh_select: function(parm) {
        console.log('强制刷新!...');
        // console.log(parm)
        this.init(parm);
      },
      init: function(parm) {

        if (typeof(parm) === 'undefined' || parm == '') {
          console.log('初始出错',parm);
          return;
        }
        let r = JSON.parse(parm);
        console.log('新select检测', r);
        this.pre_item = {};
        this.pre_item = r;
        this.pre_sel_name = '';
        this.pre_sel_val = ''; //置空，不然会 误导

        this.pre_item = JSON.parse(parm);
        this.pre_list_in = r.list_in;
        this.pre_list_out = r.list_out;


        if (r.io == 'i') {
          this.show_in = true;
          this.show_out = false;
          this.pre_list_data=this.pre_list_in;
        } else {
          this.show_in = false;
          this.show_out = true;
          this.pre_list_data=this.pre_list_out;
        }

        let id = 0;
        let temp_name = '';
        let is_go = true;
        id = r.val;
        temp_name = r.sel_name;
        // console.log('检测 id=' + id + ' temp_name=' + temp_name);

        if (Number(id) == 0 && temp_name == '') {
          this.val_back();
        }

        if (Number(id) > 0) {
          console.log('一判断');
          for (let j = 0; j < this.pre_list_data.length; j++) {
            if (this.pre_list_data[j].id == id) {
              this.pre_item.val = this.pre_list_data[j].id;
              this.pre_sel_name = this.pre_list_data[j].val;
              is_go = false;
              break;
            }
          }
        }

        if (is_go == true && temp_name != '') {
          // console.log(this.pre_list_data)
          console.log('二判断');
          for (let j = 0; j < this.pre_list_data.length; j++) {
            if (this.pre_list_data[j].val == temp_name) {
              this.pre_item.val = this.pre_list_data[j].id;
              this.pre_sel_name = this.pre_list_data[j].val;
              break;
            }
          }
          // console.log(this.pre_sel_name)
          // console.log(this.pre_item);
        }


        // console.log(this.pre_item);

        // this.val_back();
      },
      val_back: function() {
        this.$emit('com-event', this.pre_item);
      },
      fun_change: function() {
        // console.log('更新sel_name=' + this.pre_sel_name);
        // console.log('展示list=' + this.pre_list_data.length)
        // console.log('备份list=' + this.pre_list_bak.length)

        let is_back = false;
        // 模糊查询
        if (typeof(this.pre_sel_name) != "undefined" && this.pre_sel_name != '') {

          // 模糊查询
          this.pre_list_data = [];
          for (let j = 0; j < this.pre_list_bak.length; j++) {
            if (this.pre_list_bak[j].val.indexOf(this.pre_sel_name) >= 0) {
              this.pre_list_data.push(this.pre_list_bak[j]);
            }
          }


          if (this.pre_list_data.length == 0) {
            for (let j = 0; j < this.pre_list_bak.length; j++) {
              if (this.pre_list_bak[j].val == this.pre_sel_name) {
                this.pre_sel_val = this.pre_list_bak[j].val;
                this.pre_sel_name = this.pre_list_bak[j].val;
                this.pre_item.val = this.pre_list_bak[j].id;
                is_back = true;
                break;
              }
            }

          }

        } else {
          this.pre_list_data = this.pre_list_bak;
        }

      },
      choseValue: function(e) {
        this.pre_sel_name = '';
        this.pre_sel_val = '';
        console.log(e);
        
        console.log('收入支出='+this.pre_item.io);


        if (e == '') {
          console.log('清理')
          this.pre_item.val = '';
          this.pre_item.sel_name = '';
        } else {
          for (let i = 0; i < this.pre_list_data.length; i++) {
            if (this.pre_list_data[i].id == e) {
              this.pre_sel_val = this.pre_list_data[i].val;
              this.pre_sel_name = this.pre_list_data[i].val;
              this.pre_item.val = e;
              this.pre_item.sel_name = this.pre_list_data[i].val;
              break;
            }
          }
        }

        // console.log('sel_name=' + this.pre_sel_name);
        this.val_back();
      }
    }
  }
</script>

<style scoped="scoped">
  .pre-inline {
    display: inline-block;
    vertical-align: middle;
  }

  .pre-input {
    display: inline-block;
    vertical-align: middle;

  }
</style>
